export enum TeamApprovalStatus {
	APPROVED = 1,
	PENDING = 2
}

export enum SchedulerView {
	Week = 'Week',
	Schedule = 'Schedule'
}

export enum PlayerType {
	PLAYER_ONE = 'playerOne',
	PLAYER_TWO = 'playerTwo'
}
